import React, { useEffect, useState, useRef } from 'react';
import { Box, Skeleton } from "@mui/material";

const GraphSkeletonLoader = () => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(window.innerWidth);
    const [barHeights, setBarHeights] = useState([]);

    useEffect(() => {
        const generateHeights = (count) => {
            return Array.from({ length: count }, () => {
                const height = Math.floor(Math.random() * 70) + 30; // 30% to 100%
                return `${height}%`;
            });
        };

        const updateContainerSize = () => {
            const width = containerRef.current?.offsetWidth || window.innerWidth;
            setContainerWidth(width);

            const barWithSpacing = 36; // bar width + margin (e.g., 28px bar + 16px margin)
            const barCount = Math.floor(width / barWithSpacing);
            setBarHeights(generateHeights(barCount));
        };

        updateContainerSize();
        window.addEventListener("resize", updateContainerSize);
        return () => window.removeEventListener("resize", updateContainerSize);
    }, []);

    return (
        <Box ref={containerRef} sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <Box
                className="graph-view-scaleton-loader"
                sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "start",
                    height: "300px",
                    padding: "0 16px",
                    overflow: "hidden",
                }}
            >
                {barHeights.map((height, idx) => (
                    <Skeleton
                        key={`bar-${idx}`}
                        variant="rounded"
                        height={height}
                        width={28} // Wider bars
                        sx={{ margin: "0 4px" }} // Spaced bars
                    />
                ))}
            </Box>

            <Box
                sx={{
                    display: "flex",
                    gap: "20px",
                    justifyContent: "end",
                    padding: "4px 16px 8px 16px",
                }}
            >
                <Skeleton variant="rounded" width={100} height={20} />
                <Skeleton variant="rounded" width={100} height={20} />
            </Box>
        </Box>
    );
};

export default GraphSkeletonLoader;
